import React, { useEffect } from 'react';

import i18next from 'i18next';

const menus = [
  {
    name: 'SIDE_MENU.BUY_YOUR_TICKET',
    link_es: '/es/pasajes-bus',
    link_en: '/es/pasajes-bus',
  },
  // {
  //   name: 'SIDE_MENU.ABOUT_US',
  //   //  link_es: '/es/pages/about', link_en: '/en/pages/about'
  // },
  // {
  //   name: 'SIDE_MENU.DESTINATIONS',
  //   // link_es: '/es/pages/destinos',
  //   // link_en: '/en/pages/destinations',
  // },
  // {
  //   name: 'SIDE_MENU.PETS_ON_BOARD',

  //   // link_es: '/es/pages/about', link_en: '/en/pages/about'
  // },
  {
    name: 'SIDE_MENU.AGENCIES',
    link_es: '/es/pages/agencies',
    link_en: '/en/pages/agencies',
  },
  // {
  //   name: 'SIDE_MENU.FLEET',

  //   // link_es: '/es/pages/travel-agency', link_en: '/en/pages/about'
  // },
  {
    name: 'SIDE_MENU.SPECIAL_SERVICES',
    link_es: '/es/pages/special-services',
    link_en: '/es/pages/special-services',
  },
  // {
  //   name: 'SIDE_MENU.PULLMAN_GO',
  //   link: 'https://www.pullmango.cl/',
  //   link: 'https://www.pullmango.cl/',
  // },
  // {
  //   name: 'SIDE_MENU.TANDEM',
  //   link: 'https://www.tandemindustrial.cl/',
  //   link: 'https://www.tandemindustrial.cl/',
  // },
  {
    name: 'SIDE_MENU.BUSINESS_CUSTOMER',

    link: 'https://pullmanempresas.cl/',
    link: 'https://pullmanempresas.cl/',
  },

  {
    name: 'SIDE_MENU.KNOW_YOUR_RIGHTS',
    link_es: '/es/pages/know-your-rights',
    link_en: '/en/pages/know-your-rights',
  },
  {
    name: 'SIDE_MENU.PRIVACY_POLICIES',
    link_es: '/es/pages/privacy-policy',
    link_en: '/en/pages/privacy-policy',
  },
  { name: 'SIDE_MENU.TERMS_AND_CONDITIONS', link_es: '/es/pages/tnc', link_en: '/en/pages/tnc' },
  { name: 'SIDE_MENU.SALE_OF_USED_BUSES', link: 'https://api.pullman.cl/stuWAR/#/marketplace',  },

  {
    name: 'SIDE_MENU.CONTACT',
    link_es: '/es/pages/contact',
    link_en: '/en/pages/contact',
  },
];

const MenuItem = ({ menu, history, closeMenu, t }) => {
  return (
    <div
      className={
        'menu-item  ' +
        (window.location.pathname == (i18next.language == 'es' ? menu.link_es : menu.link_en) &&
          'bold-text')
      }
      onClick={() => {
        if (menu.link_es && menu.link_en) {
          history.push(i18next.language == 'es' ? menu.link_es : menu.link_en);
          closeMenu();
        } else if (menu.link) {
          window.open(menu.link);
        }
      }}
    >
      <span>{t(menu.name)}</span>
    </div>
  );
};

const SideMenu = ({ history, showMenu, closeMenu, t }) => {
  useEffect(() => {
    // eslint-disable-next-line
  }, []);

  return (
    <div className={'main-side-menu ' + (showMenu && 'show-menu')}>
      <div className="side-menu-backdrop" onClick={closeMenu}></div>
      <div className="side-menu-left white-text">
        <div className="side-menu-close">
          <div onClick={closeMenu}>
            {t('SIDE_MENU.CLOSE')}
            <img src="/images/icons/cross.png" />
          </div>
        </div>

        <div className="side-menu-title bold-text">
          <div>{t('SIDE_MENU.MENU')}</div>
          <div className="yellow-line"></div>
        </div>
        <div className="side-menu-list">
          {menus.map((menu, i) => (
            <MenuItem t={t} key={i} menu={menu} history={history} closeMenu={closeMenu} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default SideMenu;



// WEBPACK FOOTER //
// ./src/features/common/SideMenu/SideMenu.js